(() => {
  const lazyImages = document.querySelectorAll(".lazy__img");

  lazyImages.forEach((img) => {
    if (!img.complete) {
      img.addEventListener("load", () => {
        img.classList.remove("lazy__img--loading");
      });
    } else {
      img.classList.remove("lazy__img--loading");
    }
  });
})();
